//  -----   FUNZIONAMENTO   -----
/** 
- components > SidebarMenu.vue: 
viene definito un button con un onmousedown listener che chiama la funzione resize, memorizzando la coordinata X del click del mouse

- components > Sidebar.vue e components > Dash.vue > .content-wrapper:
ad ogni evento di mouseup rilevato nella sidebar o nel wrapper dei contenuti, viene richiamata stop_res(): 
se start_w è diverso da 0, allora viene interpretato come un tentativo di resize della sidebar.

- ci sono 5 componenti critici per l'adattamento dei contenuti conseguente al resize:
Dash.vue > .main-header > .logo ,   Sidebar.vue > aside
con classe .wtree, vengono ridimensionati al nuovo valore

Dash.vue > .navbar-static-top ,   Dash.vue > .content-wrapper,   Dash.vue > .main-footer
con classe .mtree, il cui margine sinistro deve necessariamente coincidere con la larghezza (aggiornata) della sidebar

!!!!!!!!
se onmouseup si verifica nei componenti footer, navbar e logo, il tentativo di resize non viene interpretato, e ci si assicura di resettare start_w 
*/

export default {
  mounted: function () {
    this.$nextTick(function () {
      this.grab_table = '.resizable_table'
      this.grab_fake_table = '.fake_resizable_table'
      this.attachListeners();
      this.$nextTick(this.initTableAndAdjust);

    })
  },
  data: function () {
    return {
      device: "desktop",
      start_h: 0, //punto della finestra in cui si inizia a trascinare la tabella
      grab_table: '',
      grab_fake_table: ''
    }
  },
  methods: {
    adjust(){
      this.$nextTick(function(){
        this.setGridEmbedHeight(310);
      })
    },
    attachListeners: function () {
      var vm = this;
      var starting_elem = $('.table-resize-start'); //è il button

      starting_elem.on("mousedown", function (e) { //DESKTOP
        var height = $(vm.grab_table).height();
        vm.start_resize(height);
      });

      starting_elem.on("touchstart", function (e) { //PORTABLE
        var height = $(vm.grab_table).height();
        vm.start_resize(height);
      });
    },
    reset_resize: function () {
      this.start_h = 0;
      var stopping_elem = $('.table-resize-stop');
      //rimuovo i listeners mousemove e mouseup a sidebar e container
      stopping_elem.off()
      //resetto larghezza placeholder e lo setto in background
      $(this.grab_fake_table).css("z-index", -1);
      $(this.grab_fake_table).height(0)
    },
    start_resize: function (y) {
      var vm = this;
      this.start_h = window.outerHeight - y;
      var stopping_elem = $('.table-resize-stop');
      var resetting_elem = $('.table-resize-reset');

      stopping_elem.on("mousemove", function (e) { //DESKTOP
        //setto placeholder in primo piano, così da vedere l'effetto di trasparenza 
        $(vm.grab_fake_table).css("z-index", 811);
        vm.apply(e.screenY, true);
      });

      stopping_elem.on("touchmove", function (e) { //PORTABLE
        //setto placeholder in primo piano, così da vedere l'effetto di trasparenza 
        $(vm.grab_fake_table).css("z-index", 811);
        vm.apply(e.originalEvent.changedTouches[0].screenY, true);
      });

      stopping_elem.on("mouseup", function (e) { //DESKTOP
        vm.stop_resize(e.screenY);
      });

      stopping_elem.on("touchend", function (e) { //PORTABLE
        vm.stop_resize(e.originalEvent.changedTouches[0].screenY);
      });

      resetting_elem.on("mouseup", function () { //DESKTOP
        vm.reset_resize();
      });

      resetting_elem.on("touchend", function () { //PORTABLE
        vm.reset_resize();
      });

    },
    stop_resize: function (y) {
      var stopping_elem = $('.table-resize-stop');
      //rimuovo i listeners mousemove e mouseup a sidebar e container
      stopping_elem.off();
      //setto placeholder in background
      $(this.grab_fake_table).css("z-index", -1);
      $(this.grab_fake_table).height(0)

      if (this.start_h != 0) {
        this.apply(y, false);
      } else {
        this.start_h = 0;
      }
    },
    apply: function (end_h, fake, fake_start) {
      var grab_h,
        grab_adjust,
        start;

      //grab_h contiene il selector a grab_table o grab_fake_table a seconda di cosa si sta calcolando
      if (!fake) {
        start = this.start_h;
        grab_h = this.grab_table;
        grab_adjust = '.table-resize-adjust';

        var difference = start - end_h;
        var height = $(grab_h).height();
        var new_size = (height + difference);
        //Minimo: 100px, Massimo: Metà Altezza Wrapper
        new_size = Math.min((Math.max(200, new_size)), ((window.outerHeight / 2) - 50));

        $(grab_h).height(new_size + 'px');
        this.setGridEmbedHeight(new_size)
        this.start_h = 0;

        var adjust_size = (window.innerHeight - new_size - 50);

        $(grab_adjust).css('max-height', adjust_size + 'px');
        $(grab_adjust).css('min-height', adjust_size + 'px');
        $(grab_adjust).css('height', adjust_size + 'px');


      } else {
        grab_h = this.grab_fake_table

        var new_size = (window.outerHeight - end_h) + 'px';
        $(grab_h).height(new_size);
      }
    },
    initTableAndAdjust: function () {
      $(this.grab_table).height('310px');
      this.setGridEmbedHeight(310);

      var adjust_size = (window.innerHeight - 360);
      $('.table-resize-adjust').css('max-height', adjust_size + 'px');
      $('.table-resize-adjust').css('min-height', adjust_size + 'px');
      $('.table-resize-adjust').css('height', adjust_size + 'px');

    },
    setGridEmbedHeight: function (h) {
      this.$store.commit("setLastHeight", h);
      try {
        $('#WrapperGrid').jqxGrid({
          height: h
        });
      } catch (err) {
        //console.log(err)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/table_resize_mixin.js